module.exports = __webpack_public_path__ + "static/media/tile-11.d2a2f36f.png";